import { z } from "zod";
import { ExternalIdEntrySchema } from "./external-id.schema";

export const TerritorySchema = z.object({
  id: z.string().uuid().describe("ID"),
  business_id: z.string().uuid().nullable().describe("Business"),
  account_id: z.string().uuid().nullable().describe("Account"),
  name: z.string().describe("Name"),
  region: z.string().nullable().describe("Region"),
  settings: z.record(z.unknown()).describe("Settings"),
  custom_fields: z
    .record(z.unknown())
    .nullable()
    .optional()
    .describe("Custom Fields"),
  boundary: z.any().nullable().describe("Boundary"),
  center_point: z.any().nullable().describe("Center Point"),
  created_at: z.string().describe("Created At"),
  updated_at: z.string().describe("Updated At"),
  external_ids: ExternalIdEntrySchema.array()
    .optional()
    .describe("External IDs"),
});
export type Territory = z.infer<typeof TerritorySchema>;

export const TerritoryInsertSchema = z.object({
  name: z.string().describe("Name"),
  region: z.string().optional().describe("Region"),
  settings: z.record(z.unknown()).optional().describe("Settings"),
  custom_fields: z.any().optional().describe("Custom Fields"),
  boundary: z.any().optional().describe("Boundary"),
  center_point: z.any().optional().describe("Center Point"),
});

export const TerritoryUpdateSchema = TerritoryInsertSchema.partial();

export const TerritoryQuerySchema = z.object({
  region: z.string().optional(),
});
